/**
 * Shared dayjs plugin registration.
 *
 * Importing this module is a side-effect: it extends dayjs with every plugin
 * the application relies on and sets the locale to English.
 *
 * Used by:
 *  - src/app/ClientRoot.tsx          (client-side)
 *  - instrumentation.ts              (Next.js server-side)
 *  - src/utils/mocks.ts              (Jest tests)
 *  - .storybook/preview.mjs          (Storybook)
 */
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/en';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(quarterOfYear);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.locale('en');
